import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { IRootState, Selector } from '../../redux/rootReducer';
import * as videoInfoSelectors from '../../redux/videoInfo/selectors';
import * as videoOutputOperations from '../../redux/videoOutput/operations';
import * as videoStyleActions from '../../redux/videoStyle/actions';
import * as videoStyleSelectors from '../../redux/videoStyle/selectors';
import * as wizardSessionActions from '../../redux/wizzardSession/operations';
import { IWizardFlowContextData } from './types';
import { createWizardFlowController } from './wizardFlowController';
import type { IWizardFlowController } from './wizardFlowController';

interface IWithWizardFlow {
  wizard: IWizardFlowController;
}

const getWizardFlowContextData: Selector<IWizardFlowContextData> =
  createStructuredSelector({
    isBusiness: videoInfoSelectors.isBusinessFlow,
    isShortFlowActive: videoStyleSelectors.isShortFlowActive,
  });

function withWizardFlow(currentState) {
  return connect(
    // wizard context data
    (state: IRootState) => getWizardFlowContextData(state),
    // wizard context actions
    {
      createVideoOutput: videoOutputOperations.createVideoOutput,
      deactivateShortFlow: videoStyleActions.deactivateShortFlow,
      startWizardSession: wizardSessionActions.startWizardSession,
    },
    (stateProps, dispatchProps, ownProps) => ({
      ...ownProps,
      wizard: createWizardFlowController(currentState, {
        ...stateProps,
        ...dispatchProps,
      }),
    }),
  );
}

export type { IWithWizardFlow, IWizardFlowController };

export default withWizardFlow;
